import React from "react";
import { useMutation } from "react-query";
import { deleteOfficeAccount } from "../../../../../actions/Utilities/OfficeAccount";
import { toast } from "../../../../../components/toastNotification";
import { useRecoilState, useSetRecoilState } from "recoil";
import { editStateOfficeAccount, officeAccountReFetching } from "../atoms";

export default function useDisableOfficeAccount() {
  const setActionEditState = useSetRecoilState(editStateOfficeAccount);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeAccountReFetching
  );
  
  const { mutate } = useMutation((ids: number[]) => deleteOfficeAccount(ids), {
    onSuccess: (res: any) => {
      switch (res) {
        case "Success":
          toast.fire(
            "Success",
            "Office Account Disabled Successfully",
            "success"
          );
          break;
        case "Notification insert Failed!":
          toast.fire(
            "Success ",
            `Office Account Disabled Successfully, BUT ${res}`,
            "warning"
          );
          break;
        case "Operation Failed!":
            toast.fire(
                "Disabling Office Account failed ",
                `Server Error: ${res}`,
                "error"
            );
            break;
        case "Office Account not found":
          toast.fire(
            "Disabling Office Account failed ",
            `Error: ${res}`,
            "error"
          );
          break;
        default:
          toast.fire("Disabling Office Account failed", res.Message, "error");
      }
        
      // Redirect to View
      setActionEditState(false);
      
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling Office Account failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}
